import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

const F = [["tarih", "TARİH", "date"], ["takip_no", "TAKİP NO"], ["gonderen_firma", "GÖNDEREN"], ["alici_firma", "ALICI"], ["alici_il", "ALICI İL"], ["alici_ilce", "ALICI İLÇE"], ["alici_adres", "ALICI ADRES"], ["adet", "ADET"], ["birim", "KARGO TÜRÜ"], ["yekun", "TUTAR (KDV'SİZ)"]];

export function OutEditDialog({ c, onClose, onSaved }) {
  const [f, setF] = useState({});
  useEffect(() => { if (c) setF(Object.fromEntries([...F.map(([k]) => [k, k === "birim" ? c.data?.koli_palet || c.data?.birim || "" : c.data?.[k] ?? ""]), ["odeme", c.data?.odeme || ""]])); }, [c]);
  const save = async () => {
    try { await api.put(`/outgoing-cargo/${c.id}`, { data: f }); toast.success("KARGO DÜZELTİLDİ"); onSaved(); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  return (
    <Dialog open={!!c} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="out-edit-dialog" className="max-w-2xl border-slate-700 bg-slate-900 text-slate-100">
        <DialogHeader><DialogTitle>GİDEN KARGO DÜZELT — {c?.data?.takip_no}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-2 text-xs">
          {F.map(([k, l, t]) => (
            <label key={k} className="space-y-0.5"><span className="text-slate-400">{l}</span>
              <input data-testid={`out-edit-${k}`} type={t || "text"} value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-8 w-full rounded border border-slate-700 bg-slate-800 px-2 text-slate-100" /></label>
          ))}
          <label className="space-y-0.5"><span className="text-slate-400">ÖDEME</span>
            <select data-testid="out-edit-odeme" value={f.odeme || ""} onChange={(e) => setF({ ...f, odeme: e.target.value })} className="h-8 w-full rounded border border-slate-700 bg-slate-800 px-2 text-slate-100">{["", "PÖ", "CH", "UA"].map((x) => <option key={x} value={x}>{x || "—"}</option>)}</select></label>
        </div>
        <p className="text-[10px] text-slate-500">FATURALAŞMIŞ / RESMİLEŞMİŞ KARGO DEĞİŞTİRİLEMEZ. İL / İLÇE DEĞİŞİRSE ALICI ŞUBE YENİDEN BULUNUR.</p>
        <div className="flex justify-end gap-2"><Button variant="outline" onClick={onClose} className="border-slate-700">VAZGEÇ</Button><Button data-testid="out-edit-save" onClick={save} className="bg-blue-600 text-white">KAYDET</Button></div>
      </DialogContent>
    </Dialog>
  );
}
